import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const faqs = [{
  q: 'Can’t we just use the free checklists?',
  a: 'You can — and most couples do, which is exactly why more than half of them still end up thousands of dollars over budget. A free checklist is the index. This is the book: the same tasks, but with the month they belong to, the order they have to happen in, the numbers already done, and the templates to actually execute them. You’re not paying for a list of what. You’re paying for the when.'
}, {
  q: '300 pages sounds like a lot. Will we actually use it?',
  a: 'You’ll never read 300 pages. You read one volume — the phase you’re living — and it’s around 50. That’s the entire point of splitting it into six. And Bonus 1 tells you exactly what to do in your first two weeks, so there’s no “where do I even start.”'
}, {
  q: 'Our wedding is in 5 months. Is it too late?',
  a: 'No — start at the volume that matches your runway and work forward. Volume 1’s budget and guest-list math are worth opening at any point, because the forgotten lines don’t care what month it is. Short runways are where sequence matters most.'
}, {
  q: 'We’re not really “planner people.”',
  a: 'Perfect. This exists precisely so you don’t have to think about the wedding every day. Twenty minutes, the volume of the month, three decisions, closed. It’s the opposite of a planning hobby.'
}, {
  q: 'Our venue has a coordinator — do we still need this?',
  a: 'A venue coordinator takes care of the venue. This takes care of you: your budget, your vendors, your guest list, your timeline, and the parts of the day the venue isn’t responsible for. Volume 2 spells out exactly what a venue coordinator does and doesn’t cover.'
}, {
  q: 'Does it work for our budget / guest count / country?',
  a: 'Yes. Prices and vendors change; sequence doesn’t. The math is built to take your numbers, and the booking order works whether you have 40 guests or 240.'
}, {
  q: 'We’ve bought planning stuff before and never opened it.',
  a: 'Because it was organized by topic, so opening it meant deciding where to start. This is organized by time: the volume you need is the month you’re in. There’s no decision to make before you begin.'
}, {
  q: 'What if it’s not for us?',
  a: '7-day guarantee. Full refund, no questions asked — open it, do one Sunday with it, and if it isn’t what you needed, tell us.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-white" data-id="element-81" data-mp="23fy7b4r9qz76">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-82" data-mp="1zgpfw6jpbdes">
        <h2 id="faq-heading" className="font-serif font-normal text-ink text-[28px] sm:text-[38px] text-center" data-id="element-83" data-mp="s245nst77uaz">
          Questions, answered
        </h2>

        <ul className="mt-10 border-t border-sage/20" data-id="element-84" data-mp="o350q87gvxjj">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="border-b border-sage/20" data-id="element-85" data-mp="33qiqizzgjors" data-mpi={i}>
                <h3 data-id="element-86" data-mp="38oaifu03ravz">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full flex items-center justify-between gap-5 py-5 text-left font-medium text-ink transition-colors duration-150 ease-out hover:text-sage-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep" data-id="element-87" data-mp="38nr9v3wcdyum">
                    <span className="text-[17px]" data-id="element-88" data-mp="98xwr3a5z5q">{faq.q}</span>
                    <ChevronDownIcon className={`w-4 h-4 flex-shrink-0 text-sage transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-89" data-mp="6mpyqch9hmz" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-90" data-mp="11rvsisyce2yk">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-91" data-mp="1go3b5ou3qwbq">
                      <p className="pb-6 pr-8 text-[17px] leading-[1.6] text-ink-soft" data-id="element-92" data-mp="xrbxbuxbx9f2">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}